var path = 'app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/loadBalancers.html';
var html = "<form name=\"form\" class=\"container-fluid form-horizontal\" ng-controller=\"cfServerGroupLoadBalancersCtrl as loadBalancersCtrl\" novalidate>\n  <div class=\"modal-body\">\n    <cf-server-group-load-balancers-selector command=\"command\" application=\"application\"></cf-server-group-load-balancers-selector>\n  </div>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/loadBalancers.html
// module id = 1653
// module chunks = 0